import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CompetencyDropdownModel } from 'src/app/Models/competencyDropdownModel';
import { SubCompetencyDropdownModel } from 'src/app/Models/subCompetencyDropDownModel';
import { Router } from '@angular/router';
import { ToolsComponentService } from 'src/app/services/tools-component.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AddTrainingsService } from 'src/app/views/Trainings/add-trainings/add-trainings.service';
import { AddToolsModel } from 'src/app/Models/addToolsModel';
import { ToolTypeModel } from 'src/app/Models/toolTypeModel';
import { CompetenciesService } from 'src/app/views/competencies/competencies.service';
import { OthersService } from 'src/app/views/competencies/others/othersDataService';

@Component({
  selector: 'app-add-tools',
  templateUrl: './add-tools.component.html',
  styleUrls: ['./add-tools.component.css']
})
export class AddToolsComponent implements OnInit {
  toolTypeName: string;
  public serviceLinesValues: CompetencyDropdownModel[];
  public subServiceLinesValues: SubCompetencyDropdownModel[];
  public toolTypeValues: ToolTypeModel[];
  public AuthorIds: Users[];
  public ReviwerIds: Users[];
  public Author: number = null;
  public Reviewer: number = null;
  public selectedToolTypeId: number = null;
  public AddToolsForm: FormGroup;

  public selectedServicelineValues: CompetencyDropdownModel[];
  public selectedServicelineId: number = null;
  public editedServicelineValues: CompetencyDropdownModel[];

  public selectedSubServicelineValues: SubCompetencyDropdownModel[];
  public editedSubServicelineValues: SubCompetencyDropdownModel[];
  public selectedSubServicelineId: number = null;

  public saveToolsDetails: AddToolsModel = new AddToolsModel();
  public editToolDetails: AddToolsModel = new AddToolsModel();

  public createButton: boolean = true;
  public editButton: boolean = false;
  public isCopy: boolean = false;
  public copyButton: boolean = false;
  public isViewMode: boolean = false;
  public viewButton: boolean = false;
  public competencyname: string;
  public subCompetencyName: string;

  tooltypeid: number;


  constructor(
    private service: AddTrainingsService,
    private toastr: ToastrService,
    private _service: ToolsComponentService,
    private compservice: CompetenciesService,
    private othersService: OthersService,
    private router: Router,) {

    this.AddToolsForm = new FormGroup({
      serviceLines: new FormControl('', [Validators.required]),
      subServiceline: new FormControl('', [Validators.required]),
      toolName: new FormControl('', [Validators.required]),
      toolType: new FormControl('', [Validators.required]),
      Reviewer: new FormControl('', [Validators.required]),
      Author: new FormControl('', [Validators.required]),
      sharepointURL: new FormControl('', [Validators.required]),
    });
  }

  ngOnInit(): void {

    this.resetForm();
    this.compservice.competencyName$.subscribe(x => {
      this.competencyname = x
      if (this.competencyname == null || this.competencyname == "") {
        this.competencyname = sessionStorage.getItem("compTitle")
      }

    });
    this.othersService.name$.subscribe(name => {
      this.subCompetencyName = name;
      if (this.subCompetencyName == null || this.subCompetencyName == "") {
        this.subCompetencyName = sessionStorage.getItem("SubcompTitle")
      }
    })
    this.service.getServiceLinesForDropdown().subscribe(res => {
      this.serviceLinesValues = res.data;

      this._service.PrepopulateData$.subscribe(res => {
        this.editToolDetails = res;

        if (Object.keys(this.editToolDetails).length != 0) {
          this._service.getCopyButtonStatus().subscribe(response => {
            this.isCopy = response;
            if (this.isCopy == true) {
              this.editButton = false;
              this.copyButton = true;
              this.createButton = false;

            }
            else {
              this.editButton = true;
              this.copyButton = false;
              this.createButton = false;
            }
          })

          this._service.getViewButtonStatus().subscribe(response => {
            this.isViewMode = response;
            if (this.isViewMode == true) {
              this.viewButton = true;
            }
            else {
              this.viewButton = false;
              this.AddToolsForm.enable();
            }
          })

          for (let i of this.serviceLinesValues) {
            if (i.id == this.editToolDetails.competencyId) {
              this.selectedServicelineId = i.id
            }
          }

          this.service.getSubServiceLinesForDropdown(this.selectedServicelineId).subscribe(res => {
            this.subServiceLinesValues = res.data;
            for (let i of this.subServiceLinesValues) {
              if (i.id == this.editToolDetails.subCompetencyId) {
                this.selectedSubServicelineId = i.id
              }
            }
          })
          this.editForm();
          if (this.isViewMode == true) {
            this.AddToolsForm.disable();
          }

        }
      });
    })

    this._service.getToolType().subscribe(res => {
      this.toolTypeValues = res;
    });
    this._service.getReviewerId().subscribe(res => {
      this.AuthorIds = res.data.profiles;
      this.ReviwerIds = res.data.profiles;


    });
    this.othersService.tooltypeid$.subscribe(value => {
      this.tooltypeid = value.value;
      this.toolTypeName = value.name;
      if (this.tooltypeid == null || this.tooltypeid == 0) {
        this.tooltypeid = Number(sessionStorage.getItem("TooltypeId"))
      }
      if (this.toolTypeName == null || this.toolTypeName == '') {
        this.toolTypeName = sessionStorage.getItem("ToolTypename")
      }
    })

  }


  subCompetencies(input) {
    this.selectedServicelineValues = this.serviceLinesValues.filter(x => x.id == input);
    this.service.getSubServiceLinesForDropdown(input).subscribe(res => {
      this.subServiceLinesValues = res.data;
    })
  }

  getSubserviceLines(input: number) {
    this.selectedSubServicelineValues = this.subServiceLinesValues.filter(x => x.id == input);
  }

  getToolTypeId(input: any) {
  }
  getAuthorId(input: any) {

  }
  getReviewerId(input: any) {

  }



  resetForm() {
    this.AddToolsForm.reset();
  }

  createTool() {


    this.saveToolsDetails.competencyId = this.selectedServicelineValues[0].id;
    this.saveToolsDetails.subCompetencyId = this.selectedSubServicelineValues[0].id;
    this.saveToolsDetails.name = this.AddToolsForm.controls['toolName'].value;
    this.saveToolsDetails.toolTypeId = parseInt(this.AddToolsForm.controls['toolType'].value);
    this.saveToolsDetails.authorId = parseInt(this.AddToolsForm.controls['Author'].value);
    this.saveToolsDetails.reviewerId = parseInt(this.AddToolsForm.controls['Reviewer'].value);
    this.saveToolsDetails.sharepointURL = this.AddToolsForm.controls['sharepointURL'].value;

    this._service.addToolDetails(this.saveToolsDetails).subscribe(res => {
    })
    this.toastr.success("Tool created Successfully");
    this.resetForm();
    this.compservice.setProfileStatus(this.saveToolsDetails.competencyId);
    this.othersService.updateId(this.saveToolsDetails.subCompetencyId);
    if (this.saveToolsDetails.toolTypeId == 1) {

      this.toolTypeName = 'ToolList';
    }
    else if (this.saveToolsDetails.toolTypeId == 2) {
      this.toolTypeName = 'TemplatesList';
    }
    else if (this.saveToolsDetails.toolTypeId == 3) {
      this.toolTypeName = 'WhitePapersList';
    }
    let sendData = {
      value: this.saveToolsDetails.toolTypeId,
      name: this.toolTypeName,
    }

    this.othersService.updatetooltypeId(sendData);
    this.router.navigate([`Home/Competencies/${this.selectedServicelineValues[0].name}/${this.selectedSubServicelineValues[0].name}/Others/${this.toolTypeName}`])

  }

  editForm() {
    this.AddToolsForm = new FormGroup({
      id: new FormControl(this.editToolDetails.id, [Validators.required]),
      Reviewer: new FormControl(this.editToolDetails.reviewerId, [Validators.required]),
      Author: new FormControl(this.editToolDetails.authorId, [Validators.required]),
      toolName: new FormControl(this.editToolDetails.name, [Validators.required]),
      toolType: new FormControl(this.editToolDetails.toolTypeId, [Validators.required]),
      serviceLines: new FormControl(this.editToolDetails.competencyId, [Validators.required]),
      subServiceline: new FormControl(this.editToolDetails.subCompetencyId, [Validators.required]),
      sharepointURL: new FormControl(this.editToolDetails.sharepointURL, [Validators.required]),
    });

  }

  editTool() {
    this.saveToolsDetails.id = this.editToolDetails.id;
    this.saveToolsDetails.authorId = this.AddToolsForm.controls['Author'].value
    this.saveToolsDetails.reviewerId = this.AddToolsForm.controls['Reviewer'].value

    this.saveToolsDetails.name = this.AddToolsForm.controls['toolName'].value;
    this.saveToolsDetails.competencyId = this.AddToolsForm.controls['serviceLines'].value;

    this.saveToolsDetails.subCompetencyId = this.AddToolsForm.controls['subServiceline'].value;
    this.saveToolsDetails.toolTypeId = this.AddToolsForm.controls['toolType'].value;
    this.saveToolsDetails.sharepointURL = this.AddToolsForm.controls['sharepointURL'].value;

    this._service.addToolDetails(this.saveToolsDetails).subscribe(res => {

    })


    this.toastr.success("Tool edited Successfully");
    this.resetForm();
    this.subCompetencyName = this.subCompetencyName.replace(/\//g, '');
    this.subCompetencyName = this.subCompetencyName.split(' ').join('');
    this.router.navigate([`Home/Competencies/${this.competencyname}/${this.subCompetencyName}/Others/${this.toolTypeName}`])
  }

  copyTool() {
    this.saveToolsDetails.name = this.AddToolsForm.controls['toolName'].value;
    this.saveToolsDetails.competencyId = this.AddToolsForm.controls['serviceLines'].value;
    this.saveToolsDetails.subCompetencyId = this.AddToolsForm.controls['subServiceline'].value;
    this.saveToolsDetails.toolTypeId = this.AddToolsForm.controls['toolType'].value;
    this.saveToolsDetails.sharepointURL = this.AddToolsForm.controls['sharepointURL'].value;


    this._service.addToolDetails(this.saveToolsDetails).subscribe(res => {
      this.toastr.success("Tool created Successfully");

    })
    this.toastr.success("Tool created Successfully");
    this.resetForm();
    this.subCompetencyName = this.subCompetencyName.replace(/\//g, '');
    this.subCompetencyName = this.subCompetencyName.split(' ').join('');
    this.router.navigate([`Home/Competencies/${this.competencyname}/${this.subCompetencyName}/Others/${this.toolTypeName}`])

  }

  backToToolsGrid() {
    this.subCompetencyName = this.subCompetencyName.replace(/\//g, '');
    this.subCompetencyName = this.subCompetencyName.split(' ').join('');
    this.router.navigate([`Home/Competencies/${this.competencyname}/${this.subCompetencyName}/Others/${this.toolTypeName}`])
  }

}
interface Users {
  employeeId: number;
  name: string;
  roles: string;
}
